import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/activaciones',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteActivacionesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Activaciones</PageTitle>
      <View />
    </>
  );
};

export { ReporteActivacionesPage };
